/* eslint-disable no-duplicate-case */
import React, { useState, useEffect } from "react";

const Pollly = () => {
  return (
    <div className="pollly-frame-wrapper">
      <div className="iframe-pollly">
        <iframe
          id="pollly-iframe-LZgvgaMG"
          src="https://old.poll.ly/#/LZgvgaMG/iframe"
          scrolling="auto"
          style={{
            overflow: "scroll",
            border: "0",
            width: "100%",
            maxHeight: "800px",
            minHeight: "400px",
            marginTop: "20px",
            height: "400px",
          }}
        ></iframe>
      </div>
    </div>
  );
};

export default Pollly;
